import { GlButton, GlIcon, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { WORK_ITEM_NOTES_FILTER_ALL_NOTES, WORK_ITEM_NOTES_FILTER_ONLY_COMMENTS } from '~/work_items/constants';
export default {
    name: 'WorkItemHistoryOnlyFilterNote',
    WORK_ITEM_NOTES_FILTER_ALL_NOTES,
    WORK_ITEM_NOTES_FILTER_ONLY_COMMENTS,
    i18n: {
        information: s__("WorkItem|You're only seeing %{boldStart}other activity%{boldEnd} in the feed. To add a comment, switch to one of the following options.")
    },
    components: {
        GlButton,
        GlIcon,
        GlSprintf
    },
    emits: [
        'change-filter'
    ],
    methods: {
        selectFilter (value) {
            this.$emit('change-filter', value);
        }
    }
};
